import { render, staticRenderFns } from "./triplet-info.vue?vue&type=template&id=2869ea82&"
import script from "./triplet-info.vue?vue&type=script&lang=js&"
export * from "./triplet-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports